import type { JSX } from 'react'
export const QueueEmptyStateIllustration = (): JSX.Element => {
  return (
    <svg
      width="335"
      height="300"
      viewBox="0 0 335 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M192.222 270.075C132.439 270.075 83.8733 226.956 83.8731 173.647C83.8732 173.372 84.0972 173.148 84.3731 173.147C84.6491 173.148 84.873 173.371 84.8731 173.647C84.8733 226.297 132.878 269.075 192.222 269.075C251.586 269.075 299.57 232.078 299.57 173.647L299.57 66.0996L281.048 82.7275C280.842 82.9119 280.526 82.8949 280.342 82.6895C280.157 82.484 280.175 82.1679 280.38 81.9834L299.673 64.6621C299.863 64.4919 300.151 64.492 300.341 64.6621L319.69 81.9824C319.895 82.1665 319.913 82.4827 319.729 82.6885C319.544 82.8942 319.229 82.9116 319.024 82.7275L300.57 66.208L300.57 173.647C300.57 232.774 251.983 270.075 192.222 270.075Z"
        fill="var(--color-illustration-border)"
      />
      <g filter="url(#filter0_d_37_87792)">
        <rect
          x="22"
          y="20"
          width="240"
          height="79"
          rx="5"
          fill="var(--color-illustration-card)"
        />
        <rect
          x="22.5"
          y="20.5"
          width="239"
          height="78"
          rx="4.5"
          stroke="var(--color-illustration-border)"
        />
        <rect
          x="35"
          y="38"
          width="117"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="35"
          y="50"
          width="137"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="53"
          y="75"
          width="30"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="192"
          y="29"
          width="61"
          height="61"
          rx="5"
          fill="var(--color-illustration-secondary-element)"
        />
        <path
          d="M40.5 72C43.5376 72 46 74.4624 46 77.5C46 80.5376 43.5376 83 40.5 83C37.4624 83 35 80.5376 35 77.5C35 74.4624 37.4624 72 40.5 72ZM40.5 73.6504C40.1964 73.6505 39.9503 73.8966 39.9502 74.2002V77.5C39.9502 77.7082 40.0678 77.899 40.2539 77.9922L42.4541 79.0928C42.7257 79.2285 43.0565 79.1182 43.1924 78.8467C43.3282 78.575 43.2179 78.2443 42.9463 78.1084L41.0498 77.1602V74.2002C41.0497 73.8965 40.8037 73.6504 40.5 73.6504Z"
          fill="var(--color-illustration-accent)"
          fillOpacity="0.4"
        />
      </g>
      <g filter="url(#filter1_d_37_87792)">
        <rect
          x="22"
          y="110"
          width="240"
          height="79"
          rx="5"
          fill="var(--color-illustration-card)"
        />
        <rect
          x="22.5"
          y="110.5"
          width="239"
          height="78"
          rx="4.5"
          stroke="var(--color-illustration-border)"
        />
        <rect
          x="35"
          y="128"
          width="117"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="35"
          y="140"
          width="137"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="53"
          y="165"
          width="30"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="192"
          y="119"
          width="61"
          height="61"
          rx="5"
          fill="var(--color-illustration-secondary-element)"
        />
        <path
          d="M40.5 162C43.5376 162 46 164.462 46 167.5C46 170.538 43.5376 173 40.5 173C37.4624 173 35 170.538 35 167.5C35 164.462 37.4624 162 40.5 162ZM40.5 163.65C40.1964 163.65 39.9503 163.897 39.9502 164.2V167.5C39.9502 167.708 40.0678 167.899 40.2539 167.992L42.4541 169.093C42.7257 169.229 43.0565 169.118 43.1924 168.847C43.3282 168.575 43.2179 168.244 42.9463 168.108L41.0498 167.16V164.2C41.0497 163.897 40.8037 163.65 40.5 163.65Z"
          fill="var(--color-illustration-accent)"
          fillOpacity="0.4"
        />
      </g>
      <g filter="url(#filter2_d_37_87792)">
        <rect
          x="22"
          y="200"
          width="240"
          height="79"
          rx="5"
          fill="var(--color-illustration-card)"
        />
        <rect
          x="22.5"
          y="200.5"
          width="239"
          height="78"
          rx="4.5"
          stroke="var(--color-illustration-border)"
        />
        <rect
          x="35"
          y="218"
          width="117"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="35"
          y="230"
          width="137"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="53"
          y="255"
          width="30"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="192"
          y="209"
          width="61"
          height="61"
          rx="5"
          fill="var(--color-illustration-secondary-element)"
        />
        <path
          d="M40.5 252C43.5376 252 46 254.462 46 257.5C46 260.538 43.5376 263 40.5 263C37.4624 263 35 260.538 35 257.5C35 254.462 37.4624 252 40.5 252ZM40.5 253.65C40.1964 253.65 39.9503 253.897 39.9502 254.2V257.5C39.9502 257.708 40.0678 257.899 40.2539 257.992L42.4541 259.093C42.7257 259.229 43.0565 259.118 43.1924 258.847C43.3282 258.575 43.2179 258.244 42.9463 258.108L41.0498 257.16V254.2C41.0497 253.897 40.8037 253.65 40.5 253.65Z"
          fill="var(--color-illustration-accent)"
          fillOpacity="0.4"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_37_87792"
          x="22"
          y="20"
          width="240"
          height="80.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.6" />
          <feComposite in2="hardAlpha" operator="out" result="offsetAlpha" />
          <feFlood
            floodColor="var(--color-illustration-border)"
            floodOpacity="1"
            result="shadowColor"
          />
          <feComposite
            in="shadowColor"
            in2="offsetAlpha"
            operator="in"
            result="shadow"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_37_87792"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_37_87792"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_37_87792"
          x="22"
          y="110"
          width="240"
          height="80.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.6" />
          <feComposite in2="hardAlpha" operator="out" result="offsetAlpha" />
          <feFlood
            floodColor="var(--color-illustration-border)"
            floodOpacity="1"
            result="shadowColor"
          />
          <feComposite
            in="shadowColor"
            in2="offsetAlpha"
            operator="in"
            result="shadow"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_37_87792"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_37_87792"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_37_87792"
          x="22"
          y="200"
          width="240"
          height="80.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.6" />
          <feComposite in2="hardAlpha" operator="out" result="offsetAlpha" />
          <feFlood
            floodColor="var(--color-illustration-border)"
            floodOpacity="1"
            result="shadowColor"
          />
          <feComposite
            in="shadowColor"
            in2="offsetAlpha"
            operator="in"
            result="shadow"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_37_87792"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_37_87792"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
